<template>
    <div>
        <card title="Usuarios" icon="fas fa-users">
            <master-options @showModal="showModal" :links="links" :withExportXlsx="true" @index="index" @reset="reset" @exportToXlsx="exportToXlsx"></master-options>
            <div>
                <div class="table-responsive">
                    <manage-table :hover="true" :headers="['Nombre', 'Apellido', 'Correo', 'Perfil', 'Teléfono','Activo']"
                        :hasOptions="true">
                        <tr v-for="l in ListUsers" :key="l.id">
                            <td>{{ l.firstName }}</td>
                            <td>{{ l.lastName }}</td>
                            <td>{{ l.email }}</td>
                            <td><span class="badge badge-success ml-2" v-for="rol in l.roles" :key="rol">{{ rol
                                    }}</span></td>
                            <td>{{ l.phoneNumber }}</td>
                            <td>
                                <i v-if="l.isActive" class="fa fa-check text-success"></i>
                                <i v-if="!l.isActive" class="fa fa-ban text-danger"></i>
                            </td>
                            <td>
                                <button class="btn btn-info btn-sm mr-2" @click="showModal(l)" data-toggle="tooltip"
                                    data-placement="top" title="Editar Usuario">
                                    <i class="fas fa-edit"></i>
                                </button>
                                <button title="Eliminar Usuario" class="btn btn-danger btn-sm "
                                    @click="deleteUser(l.id, l.fullName)" data-toggle="tooltip" data-placement="top">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </manage-table>
                </div>
            </div>
            <paginator class="mt-4" :links="links"></paginator>
        </card>
        <modal id="userFormModal" :title="modalTitle" @modalClose="index">
            <user-form :user="user" @pressOk="save"></user-form>
        </modal>
    </div>
</template>

<script>
import { Get, Delete, Post, Put } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
import $ from "jquery";
import { getUrlQuery } from "../../helper/queryHelper";
import { base64ToArrayBuffer } from '@/helper/fileHelper.js';

export default {
    components: {
        Card
    },
    data() {
        return {
            ListUsers: [],
            Post,
            Delete,
            apiUrl: this.$store.getters.apiUrl,
            modalTitle: '',
            Get,
            Put,
            user: {},
            roles: [],
            links: {
                search: ''
            },
            getUrlQuery
        };
    },
    watch: {
        urlQuery: function () {
            this.index()
        }
    },
    created() {
        this.index();
    },
    methods: {
        index() {
            this.$store.commit('setLoading', true)
            this.Get(this.apiUrl + "v1/users?" + this.urlQuery, (res) => {
                this.ListUsers = res.data.data;
                this.links = res.data.links;
                this.$store.commit('setLoading', false)
            });
        },
        reset() {
            this.links = {}
            this.index()
        },
        save() {
            if (this.user.id)
                this.update()
            else
                this.store()

        },
        showModal(user) {
            if (user && user.id) {
                this.modalTitle = "Actualizar Usuario";
                this.user = user;
            } else {
                this.modalTitle = "Crear Usuario";
                this.user = {};
            }
            $('#userFormModal').modal('show');
        },
        deleteUser(id, fullName) {
            this.$swal({
                title: "¿Desea eliminar al usuario?",
                text: fullName,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33"
            }).then(result => {
                if (result.value) {
                    this.Delete(this.apiUrl + 'v1/users/' + id, () => {
                        window.toastr.success('Usuario eliminado correctamente.')
                        this.reset();
                    });
                }
            });
        },
        update() {
            this.$store.commit("setLoading", true);
            this.Put(this.apiUrl + "v1/users/" + this.user.id, this.user, () => {
                $('#userFormModal').modal('hide');
                this.$store.commit("setLoading", false);
                window.toastr.success('Usuario modificado correctamente.')
                this.reset();
            });

        },
        store() {
            this.$store.commit("setLoading", true);
            this.Post(`${this.apiUrl}v1/users/`, this.user, () => {
                this.user = {};
                $('#userFormModal').modal('hide');
                this.$store.commit("setLoading", false);
                window.toastr.success('Usuario creado correctamente.')
                this.reset();
            })

        },
        exportToXlsx() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/Users/export?" + this.urlQuery, (res) => {
				var array = base64ToArrayBuffer(res.data);
				var a = window.document.createElement("a");
				a.href = window.URL.createObjectURL(
					new Blob([array], {
						type: "application/octet-stream",
					})
				);
				a.download = "Usuarios.xlsx";
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
                this.$store.commit("setLoading", false);
			});
        },
    },
    computed: {
        urlQuery() {
            return this.getUrlQuery()
        }
    }

}

</script>